import loadable from '@loadable/component';

// 懒加载组件
const CstStatementManagement = loadable(() => import('./cstStatementManagement/CstStatementManagement'));
const InvoiceManagement = loadable(() => import('./invoiceManagement/InvoiceManagement'));
const PaymentQuery = loadable(() => import('./paymentQuery/PaymentQuery'));
const PaymentModify = loadable(() => import('./paymentQuery/paymentModify/PaymentModify'));
const CstStatementConfirmationManagement = loadable(() => import('./cstStatementConfirmationManagement/CstStatementConfirmationManagement'));
const CstStatementConfirmationModify = loadable(() => import('./cstStatementConfirmationManagement/cstStatementConfirmationModify/CstStatementConfirmationModify'));
const PaymentApplicationManagement = loadable(() => import('./paymentApplicationManagement/PaymentApplicationManagement'));
const PaymentApplicationInvoiceModify = loadable(() => import('./paymentApplicationManagement/paymentApplicationInvoiceModify/PaymentApplicationInvoiceModify'));
const InvoiceManagement2308 = loadable(() => import('./invoiceManagement2308/InvoiceManagement'));
const PaymentQuery2308 = loadable(() => import('./paymentQuery2308/PaymentQuery'));
const PaymentModify2308 = loadable(() => import('./paymentQuery2308/paymentModify/PaymentModify'));

export const subRoutes = [
  {
    path: '/CstStatementManagement',
    component: CstStatementManagement
  },
  {
    path: '/InvoiceManagement',
    component: InvoiceManagement
  },
  {
    path: '/PaymentQuery',
    component: PaymentQuery
  },
  {
    path: '/PaymentModify',
    component: PaymentModify
  },
  {
    path: '/CstStatementConfirmationManagement',
    component: CstStatementConfirmationManagement
  },
  {
    path: '/CstStatementConfirmationModify',
    component: CstStatementConfirmationModify
  },
  {
    // M262010: 供应商：发票上交申请管理
    path: '/PaymentApplicationManagement',
    component: PaymentApplicationManagement
  },
  {
    // M262010: 供应商：发票上交申请管理发票编辑
    path: '/PaymentApplicationInvoiceModify',
    component: PaymentApplicationInvoiceModify
  },
  {
    // M262012 【2308】供应商：供应商发票管理
    path: '/InvoiceManagement2308',
    component: InvoiceManagement2308
  },
  {
    // M262011 【2308】供应商：医院回款单查询
    path: '/PaymentQuery2308',
    component: PaymentQuery2308
  },
  {
    // M262011 【2308】供应商：医院回款单查询 - 明细编辑
    path: '/PaymentModify2308',
    component: PaymentModify2308
  }
];
